import { render, staticRenderFns } from "./pageMain.vue?vue&type=template&id=dbb1fbd8&scoped=true"
import script from "./pageMain.vue?vue&type=script&lang=js"
export * from "./pageMain.vue?vue&type=script&lang=js"
import style0 from "./pageMain.vue?vue&type=style&index=0&id=dbb1fbd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb1fbd8",
  null
  
)

export default component.exports